import { useQuery, UseQueryResult } from '@tanstack/react-query'
import {
  ListStockPickerInput,
  ListStockPickerResult,
} from 'services/interface/productStockPicker.interface'
import {
  listGeneralStockPicker,
  listSkuStockPicker,
  listCombinedStockPicker,
} from 'services/productApi'

export const useGeneralStockPicker = (
  input: ListStockPickerInput,
  enabled: boolean
): UseQueryResult<ListStockPickerResult, Error> =>
  useQuery({
    queryKey: ['stockPicker', 'general', input],
    queryFn: () => listGeneralStockPicker(input),
    enabled,
  })

export const useSkuStockPicker = (
  input: ListStockPickerInput,
  enabled: boolean
): UseQueryResult<ListStockPickerResult, Error> =>
  useQuery({
    queryKey: ['stockPicker', 'sku', input],
    queryFn: () => listSkuStockPicker(input),
    enabled,
  })

/** ลิสต์สต็อกรวม — มาสเตอร์ + สต็อก SKU (ใช้ในแท็บ "คลัง" ของ modal กำหนดสินค้า) */
export const useCombinedStockPicker = (
  input: ListStockPickerInput,
  enabled: boolean
): UseQueryResult<ListStockPickerResult, Error> =>
  useQuery({
    queryKey: ['stockPicker', 'combined', input],
    queryFn: () => listCombinedStockPicker(input),
    enabled,
  })
